module.exports = __webpack_public_path__ + "img/log_buuton.8f0ee2dd.png";